import { IconButton, Typography } from '@material-ui/core';
import { CloudUpload, Delete } from '@material-ui/icons';
import { Box, Grid } from '@mui/material';
import { convertFileToBase64 } from 'core/utils/convertFile';
import { FC, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './FileUploader.module.scss';

// Component to render individual file items
interface FileItemProps {
    field: any;
    index: string;
    fieldName: string;
}

const SGSFileUploader: FC<FileItemProps> = ({ field, index, fieldName }) => {
    const { control, setValue, getValues, trigger } = useFormContext();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDragging, setIsDragging] = useState(false);

    console.log(isDragging); // TODO :: remove

    // Remove selected file
    const handleFileRemove = () => {
        setValue(`${fieldName}.${index}`, null);
        trigger(`${fieldName}.${index}`);
    };

    // Check if a file is already selected
    const isFileSelected = !!getValues(`${fieldName}.${index}.${'filename'}`);

    console.log(getValues(`${fieldName}.${index}`));
    console.log(isFileSelected);

    // Handle drag-and-drop using react-dropzone with file type restrictions
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: {
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'], // DOC
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'], // DOCX
            'image/jpeg': ['.jpeg', '.jpg'], // JPG, JPEG
            'image/png': ['.png'], // PNG
        },
        onDrop: async (acceptedFiles) => {
            console.log(isDragActive);
            const file = acceptedFiles[0] || null;
            if (file) {
                const base64String = await convertFileToBase64(file);
                const fileData = {
                    filename: file.name,
                    data: base64String,
                };
                setValue(`${fieldName}.${index}`, fileData);
                trigger(`${fieldName}.${index}`);
            }
            setIsDragging(false);
        },
        onDragEnter: () => setIsDragging(true),
        onDragLeave: () => setIsDragging(false),
    });

    return (
        <Box mb={3} display="flex" flexDirection="column">
            <Grid container alignItems="center" spacing={2}>
                {/* File Label */}
                {field.libelle && (
                    <Grid item xs={12} md={4}>
                        <Typography className={styles.fileName}>{field.libelle}</Typography>
                    </Grid>
                )}

                {/* File Upload/Remove Button */}
                <Grid item xs={12} md={field.libelle ? 8 : 12}>
                    <Controller
                        name={`${fieldName}.${index}`}
                        control={control}
                        render={({ field: { onChange }, fieldState: { error } }) => (
                            <>
                                <Box display="flex" alignItems="center" justifyContent="center">
                                    {/* Display selected file name */}
                                    <Box
                                        className={styles.selectedFile}
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                        p={2}
                                        bgcolor="background.default"
                                        borderRadius={2}
                                        style={{
                                            background: 'transparent',

                                            width: '500px',
                                            height: '120px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Box>
                                            <IconButton color="primary" aria-label="Upload file" onClick={() => fileInputRef.current?.click()}>
                                                <CloudUpload style={{ fontSize: '2rem' }} />
                                            </IconButton>
                                        </Box>
                                        {isFileSelected ? (
                                            <>
                                                <Box mt={-1} display="flex" alignItems="center">
                                                    <IconButton onClick={handleFileRemove} color="secondary" aria-label="Remove file">
                                                        <Delete />
                                                    </IconButton>
                                                    <Typography variant="body2">{getValues(`${fieldName}.${index}`)?.filename}</Typography>
                                                </Box>
                                            </>
                                        ) : (
                                            <Box {...getRootProps()}>
                                                <input {...getInputProps()} ref={fileInputRef} />

                                                <Box mt={-1} display="flex" flexDirection="column" width={'100%'} className={'text-center'}>
                                                    <Typography variant="body2">Glissez-déposez ou choisissez un fichier à télécharger</Typography>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Hidden file input for fallback */}
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" // Only allow PDF, DOC, DOCX, PNG, JPG
                                        onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                            const file = e.target.files?.[0] || null;
                                            if (file) {
                                                const base64String = await convertFileToBase64(file);
                                                const fileData = {
                                                    filename: file.name,
                                                    data: base64String,
                                                };
                                                onChange(fileData);
                                                setValue(`${fieldName}.${index}`, fileData);
                                                trigger(`${fieldName}.${index}`);
                                            }
                                        }}
                                    />
                                </Box>

                                {/* Displaying the error message */}
                                {error?.type === 'file-size' && (
                                    <Box className="text-center">
                                        <Typography variant="caption" color="error">
                                            {error?.message}
                                        </Typography>
                                    </Box>
                                )}

                                {/* Handle nested error messages safely */}
                                {error && typeof error === 'object' && (
                                    <Box className="text-center">
                                        <Typography variant="caption" color="error">
                                            {error['filename']?.message || error['data']?.message || 'Erreur lors du téléchargement du fichier'}
                                        </Typography>
                                    </Box>
                                )}
                            </>
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default SGSFileUploader;
